module.exports = __webpack_public_path__ + "img/10.28d7f106.jpg";